import type { NextPage } from 'next';
import Head from 'next/head';
import styles from '../styles/Home.module.css';
// import config from '../config/qa';

import { getAbsImagePath } from '../utils/utilFunctions';

const Home: NextPage = () => (
  <>
    <Head>
      <title>VQuiz</title>
      <meta name="description" content="Vedantu Vquiz" />
      <link rel="icon" href={getAbsImagePath('/cdn/images/favicon.png')} />
    </Head>
    {/* <Script src="/cdn/login-signup/login-signup.js" /> */}
    {/* <Script src={getAbsImagePath('/cdn/js/dotlottie-player.js')} /> */}
    <main className={styles.main} id="main">
      {/* <h1 className={styles.title}>
        Welcome to the home Page of VQuiz!
      </h1> */}
      <div>All those who wanders are not lost</div>
    </main>
  </>
);

export default Home;
